import { Player } from "./player.model";

export class PairingPlayer {
   public id: string;
   public name: string;
   constructor(data?: Partial<PairingPlayer>) {
      Object.assign(this, data);
   }
}

export class Pairing {
   public pairingId: number;
   public round: number;
   public pairingPlayer: PairingPlayer;
   constructor(data?: Partial<Pairing>) {
      Object.assign(this, data);
      this.pairingPlayer = new PairingPlayer(data.pairingPlayer);
   }
}